import React from "react";
import { MenuItem, Select, Typography } from "@mui/material";
import { SelectTopicProps } from "src/components/Feedback/components/types";
import { colors } from "src/config/colors";

const SelectTopic: React.FC<SelectTopicProps> = ({ register }) => {
  return (
    <Select
      MenuProps={{ sx: { zIndex: 5001 } }}
      size="small"
      defaultValue="default"
      inputProps={{ ...register("selectTopic") }}
    >
      <MenuItem disabled value="default">
        <Typography fontSize={14} color={colors.darkBlue} component="span">
          Выбрать тему для обращения
        </Typography>
      </MenuItem>
      <MenuItem value="topic1">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Проблема с работой сайта
        </Typography>
      </MenuItem>
      <MenuItem value="topic2">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Проблема с пунктом выдачи
        </Typography>
      </MenuItem>
      <MenuItem value="topic3">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Доставили не тот товар
        </Typography>
      </MenuItem>
      <MenuItem value="topic3">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Проблема с сотрудником аптеки
        </Typography>
      </MenuItem>
      <MenuItem value="topic3">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Подключить аптеку к сервису ЦЕНЫвАПТЕКАХ
        </Typography>
      </MenuItem>
      <MenuItem value="topic3">
        <Typography fontSize={15} color={colors.darkBlue} component="span">
          Другое
        </Typography>
      </MenuItem>
    </Select>
  );
};

export default SelectTopic;
